import React from 'react';

import {
  Button,
  Box,
  Typography,
  Modal,
  CircularProgress,
} from '@mui/material';
import './InfoModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
};

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  iconSrc: string;
  text: string;
};

const InfoModal: React.FC<Props> = ({
  open,
  loading = false,
  onClose,
  iconSrc,
  text,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {loading && (
          <CircularProgress
            color='secondary'
            size='64px'
            style={{ display: 'block', margin: '24px auto' }}
          />
        )}
        {!loading && (
          <div>
            <img src={iconSrc} alt={text} />
            <Typography sx={{ mt: 1 }}>{text}</Typography>
            <Button
              onClick={onClose}
              variant='contained'
              color='primary'
              disableElevation
              sx={{
                width: 160,
                height: 48,
                marginTop: '20px',
                borderRadius: '15px',
              }}
            >
              <Typography color='white'>OK</Typography>
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default InfoModal;
